import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7020df6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DeliveryCompaniesListItem" }
const _hoisted_2 = {
  key: 0,
  class: "mt-3 flex items-center justify-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_ctx.item.name), 1),
    _createElementVNode("p", null, "БИН: " + _toDisplayString(_ctx.item.bin || '-'), 1),
    (
                _ctx.havePermissions(['call-center-companies-update', 'all-root-permission']) ||
                _ctx.havePermissions(['call-center-companies-delete', 'all-root-permission'])
            )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_button_dropdown, { title: "Выберите действие" }, {
            default: _withCtx(() => [
              (_ctx.havePermissions(['call-center-companies-update', 'all-root-permission']))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: `/companies/spark-kz/update/${_ctx.item.id}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_the_button, { class: "primary small text" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Редактировать ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
              (_ctx.havePermissions(['call-center-companies-delete', 'all-root-permission']))
                ? (_openBlock(), _createBlock(_component_the_button, {
                    key: 1,
                    class: "red small text",
                    loading: _ctx.state.is_delete_loading,
                    onClick: _ctx.onDelete
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Удалить ")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}